import { render, staticRenderFns } from "./administrationAgentInfo.vue?vue&type=template&id=135fb44c&scoped=true&"
import script from "./administrationAgentInfo.vue?vue&type=script&lang=js&"
export * from "./administrationAgentInfo.vue?vue&type=script&lang=js&"
import style0 from "./administrationAgentInfo.vue?vue&type=style&index=0&id=135fb44c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fb44c",
  null
  
)

export default component.exports